










import Vue from 'vue';
import Head from './components/HI0001.vue';
export default Vue.extend({
  components: {
    Head,
  },
});
